<div class="family-list-root" *transloco="let t">
  <div class="header">
    <div class="name">{{ labels.familyName }}</div>
    <span class="region-label">{{ labels.productsCount }}</span>
    <span class="access-label">{{ labels.activeVip }}</span>
  </div>
  <div class="divider"></div>
  <div class="family-list">
    <div *ngFor="let item of familyItems">
      <app-family-list-item [familyData]="item"
                            [vipConfigSeriesData]="vipConfigSeriesMap[item['id']]"
                            (requestRefresh)="refresh()">
      </app-family-list-item>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
</div>
